import { render, staticRenderFns } from "./ModifyBasicDataForm.vue?vue&type=template&id=d93e8d64&scoped=true"
import script from "./ModifyBasicDataForm.vue?vue&type=script&lang=js"
export * from "./ModifyBasicDataForm.vue?vue&type=script&lang=js"
import style0 from "./ModifyBasicDataForm.vue?vue&type=style&index=0&id=d93e8d64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d93e8d64",
  null
  
)

export default component.exports